import React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'underscore';
import CargomaticCard from 'components/v2/card';

import LabelValue from 'components/ui/tailwind/label-value';
import {
  getAddressString,
  hasAddress,
} from 'utils/transformers/AddressTransformer';
import EditButton from '../../../v2/buttons/EditButton';
import 'utils/selectize';

const ConsigneeAddressCard = ({ consignee, onEditAccount }) => {
  const { t } = useTranslation();
  const renderAddress = () => {
    const { address } = consignee;
    const addressString = getAddressString(address);
    return <LabelValue value={addressString} icon="map-marker" />;
  };
  return (
    <CargomaticCard
      className="mb-6"
      header={() => (
        <header onClick={() => onEditAccount()}>
          <div className="flex items-center justify-between">
            <h3 className="my-0">{t('ADDRESS_DETAILS')}</h3>
            <EditButton />
          </div>
        </header>
      )}
    >
      {hasAddress(consignee.address) && renderAddress(consignee.address)}
      {!hasAddress(consignee.address) && (
        <LabelValue value={t('NO_ADDRESS_ON_FILE')} icon="map-marker" />
      )}
    </CargomaticCard>
  );
};
export default ConsigneeAddressCard;
